import {
    Log, LogLevel,
} from 'one-log';

import '../../ccw-app/one-epics/authtoken/src/index';
import {
    init,
} from 'ccw-app';

import {
    loader,
} from 'one-web-loader';
import { buildTsConfig } from './buildTsConfig';
import {
    callSettingsApi,
    loadSettingsFromApi,
    parseQueryString,
    waitForIntermediaAgentLogin,
    waitForIntermediaCallId,
} from 'one-ts-config';

import { enableTrace } from "one-trace";

import {
    AlertNotification
} from "one-alert-notification";

import {
    BrowserLogger,
} from 'one-web-logger';
import { HAServer, HAServerOne } from 'one-server-local-ha';

// set up the logger
const log = new Log("ccw-app",[
    new BrowserLogger(),
],LogLevel.DEBUG);

const tsConfig = buildTsConfig();

const getIntermediaCallIdFromUrl = (): string | null => {
    const params = parseQueryString(window.location.search);
    const callId = params.callid;

    return callId && `${callId}`.length > 0 ? `${callId}` : null;
};

loader({
    log,
    tsConfig,
    fetchSettings: callSettingsApi,
}, (options: any) => (
    new Promise(async (resolve) => {
        const {
            settings,
            resolver,
            tsConfig,
            tsConfigAccess,
            settingsDeferred,
        } = options;

        let activeSettings = settings;
        let fullSettingsLoaded = !settingsDeferred;

        // Agent resolve is independent of getsettings (cti + ehr only).
        // Run in background so a slow/failed sessions match cannot block settings.
        const resolveAgentInBackground = () => {
            waitForIntermediaAgentLogin(tsConfigAccess)
                .then(() => {
                    log.info(
                        'ccw-app-intermedia',
                        'Intermedia agent resolved',
                        { agentId: sessionStorage.getItem('intermedia_userid') },
                    );
                })
                .catch((exp) => {
                    log.error('ccw-app-intermedia', 'Intermedia agent resolve failed', exp);
                });
        };

        // fetchOnLogin: wait for callid, then getsettings immediately.
        // Agent sessions/voice resolve runs in parallel (does not gate settings).
        if (settingsDeferred && getIntermediaCallIdFromUrl()) {
            resolveAgentInBackground();
            try {
                activeSettings = await loadSettingsFromApi(tsConfig, {
                    fetchSettings: callSettingsApi,
                });
                fullSettingsLoaded = true;
                log.info('ccw-app-intermedia', 'Full settings loaded after callid (agent resolve in parallel)');
            } catch (exp) {
                log.error('ccw-app-intermedia', 'Failed to load settings before init', exp);
            }
        }

        /**
         * check for the log level config from settings and set default
         */
        const {logconfig,alertnotify} = activeSettings;
        if(logconfig?.level==="INFO"){
            log.setlevel(LogLevel.INFO);
        } else  if(logconfig?.level==="WARN"){
            log.setlevel(LogLevel.WARN);
        } else  if(logconfig?.level==="ERROR"){
            log.setlevel(LogLevel.ERROR);
        } else{
            log.setlevel(LogLevel.DEBUG);
        }
        log.debug(
            'ccw-app-intermedia',
            'app settings', {
            settings: activeSettings,
        });

          const agentId = sessionStorage.getItem('intermedia_userid') ?? '';
          // adding ani
          const ani = '';
          let alertnotification = new AlertNotification(false,alertnotify?.url,{
                             });
          if(alertnotify?.enable){
            alertnotification = new AlertNotification(true,alertnotify?.url,{
              customer_name:alertnotify?.customer,
              server_id:alertnotify?.servername,
              app_type:"web"
          })
          }
            // enable user specific trace
            enableTrace(agentId, {
                log,
                settings: activeSettings,
            });

        // initialize the app
        const {
            store,
            mergeSettings,
        } = await init('app', {
            log,
            tsConfigAccess,
            tsConfig,
            agentId,
            ani,
            settings: activeSettings,
            resolver,
            alertnotification,
            server: new HAServer(
                activeSettings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
            serverone: new HAServerOne(
                activeSettings['servers'],
                (url:string,error: any) => {
                    store.dispatch({
                        type: "one-state-errorhandle/set",
                        payload: {
                            url: url,
                            error: error,
                            monitor: false
                        }
                    })
                }
            ),
        });

        let fullSettingsLoading = false;

        const applyFullSettings = async () => {
            if (fullSettingsLoaded || fullSettingsLoading) {
                return;
            }

            fullSettingsLoading = true;

            try {
                const fullSettings = await loadSettingsFromApi(tsConfig, {
                    fetchSettings: callSettingsApi,
                });
                mergeSettings(fullSettings);
                fullSettingsLoaded = true;
                log.info('ccw-app-intermedia', 'Full settings loaded after callid');
            } catch (exp) {
                log.error('ccw-app-intermedia', 'Failed to load settings after callid', exp);
            } finally {
                fullSettingsLoading = false;
            }
        };

        if (settingsDeferred && !fullSettingsLoaded) {
            // No callid yet: wait for it, then settings + background agent resolve.
            waitForIntermediaCallId()
                .then(() => {
                    resolveAgentInBackground();
                    return applyFullSettings();
                })
                .catch((exp) => {
                    log.error('ccw-app-intermedia', 'Timed out waiting for Intermedia callid', exp);
                });
        } else if (settingsDeferred && fullSettingsLoaded) {
            // Settings already loaded; keep trying agent if not cached yet.
            if (!sessionStorage.getItem('intermedia_userid')) {
                resolveAgentInBackground();
            }
        }

        resolve({
            log,
            // next is optional
            next: (params: any) => {
                console.debug(
                    'ccw-app-intermedia',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({
                    store,
                });
            },
        });
    })
));
